/* eslint-disable prettier/prettier */
/* prettier-ignore-file */

import { apiService } from './api.service';

export interface Role {
	id: string;
	name: string;
	description?: string;
	isactive: boolean;
	hierarchylevel: number;
	permissions: {
		id: string;
		name: string;
		description?: string;
		category?: string;
	}[];
}

export const roleService = {
	async getAllRoles(): Promise<Role[]> {
		try {
			const response = await apiService.get<Role[]>('/role/rolelist');

			if (!response.success) {
				throw new Error(response.message);
			}

			return response.data;
		} catch (error: any) {
			console.error('Role fetch error:', error);
			throw new Error(error.message || 'Failed to fetch roles');
		}
	},
};
